import {Component, Input, OnInit, signal, inject} from '@angular/core';
import {
  AGENCY_MENU_ITEM,
  FIX_MY_CODE_SUB_MENU_ITEM,
  MenuItem,
  REGULATION_MENU_ITEM,
  SIDE_NAV_MENU,
  SUPPORT_SERVICES,
} from './menu-items';
import {ActivityTrackingService} from '../../../../auth/shared/services/activity-tracking.service';
import {UserInfoQuery} from '../../../../common/elf-store/user-info/user-info.query';
import {UserInfoState} from '../../../../common/elf-store/user-info/user-info.type';
import {environment} from 'src/environments/environment';
import {AuthService} from 'src/app/auth/shared/services/auth.service';
import {AutoUnsubscribe} from 'src/app/decorators/auto-unsubscribe.decorator';
import {PaginationService} from 'src/app/services/pagination.service';
import {Router} from '@angular/router';
import {SUBSCRIPTIONS} from 'src/app/common/utils/constants';
import {UserPermissions} from 'src/app/common/elf-store/user-permissions/user-permissions.store';
import {ExcludedOnlyRegTrackModeComponent} from '../../../../types/only-reg-track-mode.type';
import {AmplitudeService} from '../../../../services/amplitude.service';
import {AmplitudeManager} from '../../../../common/elf-store/amplitude/amplitude.manager';
import {TeamSelectorComponent} from '../../../dumb/team-selector/team-selector.component';
import {OnlyRegTrackModeGuardDirective} from '../../../../common/directives/only-reg-track-mode-guard.directive';
import {PermissionGuardDirective} from '../../../../common/directives/permission-guard.directive';
import {BtnComponent} from '../../../dumb/button/button.component';
import {NavMenuComponent} from '../nav-menu/nav-menu.component';
import {MatIconModule} from '@angular/material/icon';

enum MenuLabels {
  DEV_RESOURCES = 'MENU.DEV-RESOURCES',
  FIX_MY_CODE = 'DEV-RESOURCES.FIX-MY-CODE',
}

@AutoUnsubscribe()
@Component({
  standalone: true,
  selector: 'mc-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  imports: [
    TeamSelectorComponent,
    OnlyRegTrackModeGuardDirective,
    PermissionGuardDirective,
    BtnComponent,
    NavMenuComponent,
    MatIconModule,
  ],
})
export class NavigationComponent implements OnInit {
  private activityTrackingService = inject(ActivityTrackingService);
  private userInfoQuery = inject(UserInfoQuery);
  authService = inject(AuthService);
  pagination = inject(PaginationService);
  private router = inject(Router);
  private amplitudeManager = inject(AmplitudeManager);
  private amplitudeService = inject(AmplitudeService);

  @Input() isSidenavOpened: boolean;
  userEmail: string;
  becomePartnerUrl: string = environment.becomePartnerUrl;
  newPartnerEmail: string;
  userCode: string;
  isPartner: UserInfoState['isPartner'];
  // todo: add backend data
  isUserDataLoaded: boolean;

  isDashboardUpdating = signal<boolean>(false);

  regTrackMode: boolean;
  get UserPermissions() {
    return UserPermissions;
  }

  get RegTrackMode() {
    return ExcludedOnlyRegTrackModeComponent;
  }

  get isGoogle() {
    return this.userCode === 'ExVVqlph5N';
  }

  get menuItems() {
    let menuItems: MenuItem[] =
      this.authService.isAgency || this.isPartner
        ? [...SIDE_NAV_MENU, AGENCY_MENU_ITEM, SUPPORT_SERVICES]
        : [...SIDE_NAV_MENU, SUPPORT_SERVICES];
    menuItems = this.authService.isRegulationAllowed() ? [...menuItems, REGULATION_MENU_ITEM] : menuItems;

    if (this.authService.isFixMyCodeEnabled) {
      this.addFixMyCodeSubMenuItem(menuItems);
    }

    // Do NOT DELETE workaround for Google
    if (this.regTrackMode || this.isGoogle) {
      menuItems = [REGULATION_MENU_ITEM];
    }

    return menuItems;
  }

  addFixMyCodeSubMenuItem(menuItems: MenuItem[]): void {
    const devResourcesItem = menuItems.find(item => item.label === MenuLabels.DEV_RESOURCES);

    if (!devResourcesItem) {
      return;
    }

    const hasFixMyCodeSubMenu = devResourcesItem.menuItems?.some(subItem => subItem.label === MenuLabels.FIX_MY_CODE);

    if (!hasFixMyCodeSubMenu) {
      devResourcesItem.menuItems.push(FIX_MY_CODE_SUB_MENU_ITEM);
    }
  }

  onAddSite() {
    this.activityTrackingService.sideNavAddSiteEvent();
    this.amplitudeManager.setAddSiteProperties({
      addSitesTriggeredPlace: 'navbar',
      addSiteTriggeredPage: this.amplitudeService.getCurrentPage(),
    });

    this.router.navigate([`widget/${this.pagination.currentTab}/p/${this.pagination.currentPage}/add-sites`], {
      queryParams: this.pagination.getQueryParams(),
    });
  }

  ngOnInit(): void {
    this[SUBSCRIPTIONS].add(
      this.userInfoQuery.userInfo$.subscribe((info: UserInfoState) => {
        this.isPartner = info.isPartner;
        this.userEmail = info.email;
        this.isUserDataLoaded = true;
        this.userCode = info.accountCode;
        this.regTrackMode = info.regulation_tracker_mode_only;
      }),
    );
  }

  openBecomePartnerPage() {
    this.activityTrackingService.becomePartnerEvent();
    // Temporary commented due to an error on the website
    this.newPartnerEmail = `${this.becomePartnerUrl}`; // +${this.userEmail.replace('@', '%40')}`;
    window.open(this.newPartnerEmail, '_blank').focus();
  }
}
